
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Checkbox, Chip
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set, uniqBy } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import { SelectA, DatePickerA } from '../../components/form';
const { uniq } = require('lodash');
const API_HOST = CONFIG.modules['accounts'].host


export const Allotment = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts, TaskTypes, Campaigns, map } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))
    const [campaign, setCampaign] = useState('')
    const [campaignMap, setCampaignMap] = useState({})
    const [allocationsMap, setAllocationMap] = useState({})
    const [allotMentsByUser, setAllotmentsByUser] = useState([])

    const [shiftAllocations, setShiftAllocations] = useState([])
    const [shiftAllocationsMap, setShiftAllocationsMap] = useState({})

    const [tasks, setTasks] = useState([]);
    const [tasksMap, setTasksMap] = useState({});
    const [selectedTaskType, setSelectedTaskType] = useState(null)
    const [forDate, setForDate] = useState(dayjs())

    const [shiftUsers, setShiftUsers] = useState([])
    const [shiftUsersMap, setShiftUsersMap] = useState({})

    const getShiftUsers = () => {
        axios.get(API_HOST + '/shift-allocations').then((resp) => {
            if (resp.data && resp.data.success) {
              setShiftAllocations(resp.data.shiftAllocations)
              
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(() => {
        if (Campaigns) {
            setCampaignMap(Campaigns.reduce((a, c) => {
                a[c._id] = c
                return a;
            }, {}))
            setCampaign(Campaigns[0]._id)
        }
    }, [Campaigns])

    useEffect(() => {
        if (TaskTypes) {
            // setCampaignMap(Campaigns.reduce((a, c) => {
            //     a[c._id] = c
            //     return a;
            // }, {}))
            setSelectedTaskType(TaskTypes[0]._id)
        }
    }, [TaskTypes])

    useEffect(() => {
        if (campaign&& selectedTaskType) {
            axios.get(API_HOST + `/tasks?campaign=${campaign}&task=${selectedTaskType}`).then((resp) => {
                if (resp.data && resp.data.success) {
                    setTasks(resp.data.tasks)
                }
            }).catch((e) => {
                console.log(e)
            })

            axios.get(API_HOST + `/allocation?campaign=${campaign}&task=${selectedTaskType}&forDate=${dayjs(forDate).format('YYYY-MM-DD')}`).then((resp) => {
                if (resp.data && resp.data.success) {
                    setAllocationMap(resp.data.allocations.reduce((a,e)=> {
                        a[e.user._id] = e;
                        return a;
                    },{}))
                }
            }).catch((e) => {
                console.log(e)
            })
            
        }

    }, [campaign, selectedTaskType, forDate])

    useEffect(() => {
        if(Array.isArray(shiftAllocations)) {
            setShiftAllocationsMap(shiftAllocations.reduce((a,e) => {
                a[e.shift] = e
                return a
              },{}))
        }
    }, [shiftAllocations])

    useEffect(() => {
        getUsersByShifts()
        getShiftUsers()
    }, [])

    useEffect(()=> {
        if(Array.isArray(shiftUsers)) {
            // console.log('ttM', shiftUsers)
            setShiftUsersMap(shiftUsers.reduce((a,e) => {
                a[e.user] = e
                return a
            },{}))
        }
    }, [shiftUsers])

    useEffect(() => {
        if (tasks) {
            setTasksMap(tasks.reduce((a, e) => {
                a[e.user._id] = e;
                return a;
            }, {}))
        }
    }, [tasks])

    const getUsersByShifts = (shift) => {
        setShiftUsers([])
        axios.get(API_HOST + `/shifts-users`).then((resp) => {
            if (resp.data && resp.data.success) {
              setShiftUsers(resp.data.usersByshifts)
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(()=> {
        if(Object.values((tasksMap || {}).length>0)) {
            setAllotmentsByUser(Object.values((tasksMap || {})).map(u => {
                console.log('tt',shiftUsersMap[u.user._id])
                let shift = ''
                let count = 0
                if(shiftUsersMap[u.user._id] && map.Shifts[shiftUsersMap[u.user._id].shift]) {
                    let obj = map.Shifts[shiftUsersMap[u.user._id].shift]
                    
                    shift = obj?`${obj.name} (${dayjs(obj.start).format('hh:mm:A')}-${dayjs(obj.end).format('hh:mm:A')})`:'-'
                    if(obj)  {
                        let sObj = shiftAllocationsMap[shiftUsersMap[u.user._id].shift]
                        count = sObj.number ||0
                    }
                }

                const allocation = allocationsMap[u.user._id] || {}
                const {languages, noOfCalls, _id, secondaryLanguages} = allocation || {}
                return { name: u.user.name,
                    campaign: campaign,
                    languages: Array.isArray(u.user.languages)?u.user.languages.map(u=>u):[],
                    shift,
                    count,
                    forDate: forDate,
                    task: selectedTaskType,
                    id: _id
                 }
            }))
        }
    }, [tasksMap, allocationsMap])

    useEffect(() => {
        // console.log(tasksMap,allotMentsByUser, allocationsMap)
    },[allotMentsByUser, allocationsMap])




    


    return (
        <>

            <Box>
                <Box sx={{ display: 'flex',width: '30%', mt: 3 }}>
                    <SelectA field={
                        {
                            type: 'select',
                            label: 'Campaign',
                            option: { key: 'Campaigns', value: '_id', label: 'name' },
                            name: 'campaign'
                        }
                    } data={{ Campaigns }} onChange={(name, value, multiple) => {
                        setCampaign(value)
                    }} value={campaign} />
                    <SelectA field={
                        {
                            type: 'select',
                            label: 'Assigned For',
                            option: { key: 'TaskTypes', value: '_id', label: 'name' },
                            name: 'taskType',
                            
                        }
                    } sxx={{ml:2}} data={{ TaskTypes }} onChange={(name, value, multiple) => {
                        setSelectedTaskType(value)
                    }} value={selectedTaskType} />
                   
                </Box>
                <Box>
                    <Grid data={allotMentsByUser} columns={[
                        { id: 'name', label: 'Name', minWidth: 100 },
                        { id: 'shift', label: 'Shift', minWidth: 100 },
                        { id: 'count', label: 'Count', minWidth: 100 },
                        { id: 'languages', label: 'Lanuages', minWidth: 100, format: (data, row) => {
                            return Array.isArray(data)?data.map(id=>(map.Languages&& map.Languages[id]?map.Languages[id].name:'')).join(","):""
                        } }
                       
                    ]}

                    ></Grid>
                </Box>
            </Box>

        </>
    )
}